import { Component,ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, Validators, ValidationErrors, FormControl } from '@angular/forms';
import { UserManagementService } from '../service/userManagement.service';
import { Router } from '@angular/router';
import { CreateUserModel } from '../model/FormsEntity/registrationForm';
import { NotificationService } from '../core/core.module';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent {
  userManegament:CreateUserModel = new CreateUserModel();
  statusMessage:string;
  minDate:Date;
  maxDate=new Date();
  display=false;
  roleId:number;
  roles:any;
  arr:any[];
  captchaCode:string;
  checkCaptcha:string;
  wrongCaptcha:boolean = false;
  isImageLoading:boolean = false;
  imageToShow:any;
  captchaId:any;
  ImgUrl: string;
  constructor(
    private fb:FormBuilder,
    private userMenage :UserManagementService,
    private readonly notificationService: NotificationService,
    private router: Router,
    ) { }

  registrationForm = this.fb.group({
    // userName:[null,Validators.compose([
    //   Validators.required,Validators.pattern('^[a-zA-Z0-9]*$')])],
    name:[null,Validators.compose([
      Validators.required,Validators.pattern('^[a-zA-Z ]*$')])],
    mobileNo:[null,Validators.compose([
      Validators.required,Validators.pattern('^[0-9]{10}$'),
    ])],
    emailId:[null,Validators.compose([
      Validators.required,Validators.email
    ])],
    birthDate:[null,Validators.required],
    roleId:null,
    digilockerId:null,
    gender:[null,Validators.required],
    //password:[null,Validators.required],
    captcha:null,
    enterCaptcha:new FormControl('', [
      Validators.required, 
    ])
  })
  
  genderList = [
    {pk:1,name:"Male"},
    {pk:2,name:"Female"},
    {pk:3,name:"Others"}
  ]
  ngOnInit() {
    this.roleId = 11;         //role id of applicant
    this.userManegament.roleId = this.roleId;
    this.display=true;
    this.userMenage.getRoleList().subscribe(data=>
      {       
        this.roles=data;
        // console.log(data)
      }
    );    
    this.getImageFromService();
  //  var str = new Array(6).join().replace(/(.|$)/g, function () { 
  //               return ((Math.random() * 36) | 0).toString(36)[
  //               Math.random() < .5 ? "toString" : "toUpperCase"](); 
  //               });  
  //   this.captchaCode = str;  
  //  console.log(this.captchaCode)
  }
  

  getImageFromService() {
    this.isImageLoading = true;
    this.userMenage.getImage().subscribe(data => {
      this.ImgUrl = data.imageToShow;
    this.imageToShow = 'data:image/png;base64,' + data.imgData;
    //this.imageToShow = data.imgData;
    this.captchaCode = data.captchaCode;
    this.isImageLoading = false;
    this.captchaId = data.captchaId;
    // console.log(data);
    // console.log(this.captchaCode);
  }, error => {
    this.isImageLoading = false;
    console.log(error);
  });
}



  onSubmit(): void {

    if (this.registrationForm.invalid) {
      return;
      }; 
      if(this.captchaCode != this.checkCaptcha){
        this.wrongCaptcha = true;
        return;
      }else{
        this.wrongCaptcha = false;
      }  
     const param ={
      "fullName": this.userManegament.fullName,
      "emailAddress": this.userManegament.emailAddress,
      "gender":this.userManegament.gender,
      "digiLockerId":this.userManegament.digiLockerId,
      "mobileNumber": this.userManegament.mobileNumber,
      "dOB":this.userManegament.dOB,
      "roles": [{
          "code":"applicant",
          "masterRoleId":11,
          "name": "applicant",
          "fullName": "Applicant",
          "status": 1
       }
      ],
    
     }
    this.userMenage.createUser(param).subscribe(data=>{
      // console.log(data)
      if(data && data.error){
        this.notificationService.error(data.error.errorMessage);
      }else if(data && data.status){
        this.statusMessage = data.status.detailMessage;
         this.notificationService.success(data.status.detailMessage);
        this.router.navigate(['/login']);
      }
    })

    return
    if (this.registrationForm.invalid) {
      return;
      }; 
      if(this.captchaCode != this.checkCaptcha){
        this.wrongCaptcha = true;
        return;
      }else{
        this.wrongCaptcha = false;
      }  
    this.userManegament.designation = "applicant";
    this.userMenage.submitRegistrationForm(this.userManegament).subscribe(data=>{
      // console.log(data)
      if(data && data.error){
        this.notificationService.warn(data.error.errorMessage);
      }else if(data && data.status){
        this.statusMessage = data.status.detailMessage;
         this.notificationService.success(data.status.detailMessage);
        this.router.navigate(['/login']);
      }
    })
  }
  

}
 